<template>
  <div class="home">
    <v-carousel
      hide-delimiters
      hide-arrows
      :left-control-icon="false"
      :right-control-icon="false"
    >
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        :src="item.src"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
    </v-carousel>
    <!-- <div class="container">
      <backtohauptspeise></backtohauptspeise>
    </div> -->
    <v-card>
      <v-card-title class="display-3">
        Rindfleisch
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        :items-per-page="-1"
      >
        <template v-slot:item.speise="{ item }">
          <b>{{ item.speise }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
// import Backtohauptspeise from './Backtohauptspeise.vue';
export default {
  // components: { Backtohauptspeise },
  name: 'Rindfleisch',
  data() {
    return {
      items: [
        {
          src: require('../assets/images/rindfleischganbianseitlich.jpg'),
        },
        {
          src: require('../assets/images/gebratenesrindfleischmithintergrund.jpg'),
        },
        {
          src: require('../assets/images/rindfleischganbianmithintergrund.jpg'),
        },
      ],
      search: '',
      headers: [
        {
          text: 'Nummer',
          align: 'start',
          sortable: false,
          value: 'nummer',
        },
        { text: 'Speise', value: 'speise' },
        { text: 'Allergene', value: 'allergene' },
        { text: 'Preis', value: 'preis' },
      ],
      desserts: [
        {
          nummer: '115',
          speise: 'Rindfleisch mit Thai Sauce (scharf)',
          allergene: '(A, F)',
          preis: '12,50 €',
        },
        {
          nummer: '116',
          speise: 'Rindfleisch Ganbian (scharf)',
          allergene: '(A, F)',
          preis: '13,00 €',
        },
        {
          nummer: '117',
          speise: 'Rindfleisch nach Chop Suey',
          allergene: '(A, F)',
          preis: '12,50 €',
        },
        {
          nummer: '118',
          speise: 'Rindfleisch nach Sichuan Art (scharf)',
          allergene: '(A,F)',
          preis: '12,50 €',
        },
        {
          nummer: '119',
          speise: 'Rindfleisch mit Bambus und Pilzen',
          allergene: '(A,F)',
          preis: '12,50 €',
        },
        // {
        //   nummer: '120',
        //   speise: 'Rindfleisch Sesam',
        //   allergene: '(A,F)',
        //   preis: '10,40 €',
        // },
        {
          nummer: '121',
          speise: 'Gebratenes Rindfleisch mit Gemüse',
          allergene: '(A,F)',
          preis: '12,30 €',
        },
        {
          nummer: '122',
          speise: 'Gebratenes Rindfleisch mit Paprika',
          allergene: '(A,F)',
          preis: '12,30 €',
        },
        {
          nummer: '123',
          speise: 'Gebratenes Rindfleisch mit Curry Sauce',
          allergene: '(A, F)',
          preis: '12,30 €',
        },
        {
          nummer: '124',
          speise: 'Gebratenes Rindfleisch mit Zwiebeln',
          allergene: '(A, F)',
          preis: '12,30 €',
        },
        // {
        //   nummer: '125',
        //   speise: 'Gebratenes Rindfleisch mit Zucchini',
        //   allergene: '(A, F)',
        //   preis: '10,40 €',
        // },
        {
          nummer: '126',
          speise: 'Rindfleisch mit Teriyaki Sauce',
          allergene: '(A, F)',
          preis: '12,30 €',
        },
        // {
        //   nummer: '127',
        //   speise: 'Rindfleisch mit Tofu und Gemüse',
        //   allergene: '(A, F)',
        //   preis: '10,60 €',
        // },
      ],
    };
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
